import { defaultUnpatchedConsole } from "./const.js";
//#region src/unpatchedConsole/initialize.ts
let unpatchedConsole = defaultUnpatchedConsole;
function initializeUnpatchedConsole(config) {
	var _config$unpatchedCons;
	unpatchedConsole = (_config$unpatchedCons = config.unpatchedConsole) !== null && _config$unpatchedCons !== void 0 ? _config$unpatchedCons : unpatchedConsole;
	return unpatchedConsole;
}
//#endregion
export { initializeUnpatchedConsole, unpatchedConsole };

//# sourceMappingURL=initialize.js.map